module.exports = ".singin {\n  width: 85px; }\n\n.dropdown-menu.show {\n  display: block; }\n\n#dropdownMenuButton:hover {\n  cursor: pointer; }\n\n@media screen and (max-width: 580px) {\n  .navbar-brand {\n    margin-right: 0px; }\n  .dropdown-toggle {\n    margin-right: 0px;\n    font-size: 14px; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/header/header.scss
// module id = ./src/app/components/header/header.scss
// module chunks = main